module.exports = __webpack_public_path__ + "img/steering-wheel.094e780d.svg";